export const HISTORY_TYPE = {
  STAKING: 1,
  UN_STAKE: 2,
  STAKE_REWARD: 3,
  STAKE_CLAIM_REWARD: 4,
  VESTING: 5,
  P2P_DEPOSIT: 6,
  STAKE_WITHDRAW: 7,
  P2P_WITHDRAW: 8,

  // PTO
  TOKENIZE_DEPOSIT: 9,
  TOKENIZE_WITHDRAW: 10,
  TOKENIZE_REFUND: 11,
  REF_CLAIM_REWARD: 12,
  // Referral
  VESTING_HMC: 13,

  // Stake NFT
  STAKE_NFT: 14,
  UN_STAKE_NFT: 15,
  STAKE_NFT_CLAIM_REWARD: 16,
  REF_CLAIM_REWARD_USDC: 17,

  // Stake token
  STAKE_TOKEN: 18,
  UN_STAKE_TOKEN: 19,
  STAKE_TOKEN_REWARD: 20,
  STAKE_TOKEN_CLAIM_REWARD: 21,
  STAKE_TOKEN_WITHDRAW: 22,

  // Vesting Ventures
  VESTING_VENTURE: 23,
};
